import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";

import { useInboundContext } from "./../context";
import { logError } from "../../../../utils/appUtils";
import { createSeal, deleteSeal } from "../../../../graphql/mutations";
import { SealsCreate } from "./SealsCreate";
import { SealsList } from "./SealsList";
import { useNotify } from "react-admin";

const saveSeal = async ({
  currentShipment,
  sealBarCode,
  notes,
  createdBy,
  validated,
  isScanned,
}) => {
  const sealInput = {
    barcode: sealBarCode,
    description: notes,
    referenceId: currentShipment.id,
    owner: currentShipment.owner,
    groups: window.appUser.groups,
    reloadYardId: currentShipment.reloadYardId,
    accountId: currentShipment.accountId, // use primary accountId
    accountName: currentShipment.accountName, // use primary account name
    referenceName: "InboundShipment",
    validated,
    active: true,
    isScanned,
    createdBy,
  };

  const result = await API.graphql(
    graphqlOperation(createSeal, { input: sealInput }),
  );
  return result.data.createSeal;
};

const deleteSealById = async (sealId) => {
  const deleteInput = {
    id: sealId,
  };

  const result = await API.graphql(
    graphqlOperation(deleteSeal, { input: deleteInput }),
  );
  return result.data.deleteSeal;
};

const modes = ["list", "create"];

export const SealDialog = ({ setIsSealDialogOpen }) => {
  const { state, saveShipment } = useInboundContext();
  const { currentShipment } = state;
  const [saving, setSaving] = useState(false);
  const [mode, setMode] = useState(modes[0]);

  const seals = currentShipment.seals?.items || [];
  const sealsBarCodes = seals.map((seal) => seal.barcode);
  const createdBy = window.appUser.fullName;
  const notify = useNotify();

  const goToAddNewSeal = () => setMode(modes[1]);
  const goToSealsList = () => setMode(modes[0]);
  const close = () => setIsSealDialogOpen(false);

  const handleSave = async ({ notes, sealBarCode, validated, isScanned }) => {
    setSaving(true);
    try {
      await saveSeal({
        currentShipment,
        sealBarCode,
        notes,
        createdBy,
        validated,
        isScanned,
      });
      const newHistory = {
        date: new Date().toISOString(),
        by: createdBy,
        type: "SEAL_ADDED",
        text: `Seal added with barcode ${sealBarCode}`,
      };
      const updatedHistory = currentShipment.history
        ? [...currentShipment.history, newHistory]
        : [newHistory];
      const shipmentToUpdate = {
        id: currentShipment.id,
        history: updatedHistory,
      };
      await saveShipment(shipmentToUpdate);
    } catch (error) {
      logError("InboundShipments:Seals:SealDialog:handleSave", error, notify);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (sealId) => {
    setSaving(true);
    try {
      await deleteSealById(sealId);
      const { barcode } = currentShipment.seals.items.find(
        (seal) => seal.id === sealId,
      );
      const newHistory = {
        date: new Date().toISOString(),
        by: createdBy,
        type: "SEAL_DELETED",
        text: `Seal deleted with barcode ${barcode}`,
      };
      const updatedHistory = currentShipment.history
        ? [...currentShipment.history, newHistory]
        : [newHistory];
      const shipmentToUpdate = {
        id: currentShipment.id,
        history: updatedHistory,
      };
      await saveShipment(shipmentToUpdate);
    } catch (error) {
      logError("InboundShipments:Seals:SealDialog:handleDelete", error, notify);
    } finally {
      setSaving(false);
    }
  };

  if (mode === modes[1]) {
    debugger;
    return (
      <SealsCreate
        cancel={goToSealsList}
        saving={saving}
        saveSeal={handleSave}
        sealsNumbers={currentShipment.sealNumbers}
        addedSeals={sealsBarCodes}
      />
    );
  }

  return (
    <SealsList
      handleDelete={handleDelete}
      close={close}
      saving={saving}
      sealsList={seals}
      onPressAddSeal={goToAddNewSeal}
    />
  );
};
